export function base64ToFile(
    base64: string,
    name: string,
    type: "csv" | "xls"
) {
    try {
        const binaryString = atob(base64);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);

        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }

        const types = {
            csv: 'text/csv;charset=utf-8;',
            xls: 'application/vnd.ms-excel;charset=utf-8;',
        };

        // Usa o tipo correto para arquivo .xls
        const blob = new Blob([bytes], { type: types[type] });

        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', name);

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        return true;
    } catch (_) {
        return false;
    }
}